import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '@services/app.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import * as XLSX from 'xlsx-js-style';
import { saveAs } from 'file-saver';
import { WorkshopRegistrationDetails } from '@/modals/workshop-details/workshopRegistrationDetails';
import { EventBookingDetails } from '@/modals/event-details/eventBookingDetails';
import { AesEncryptionService } from '@services/aes-encryption.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import Swal from 'sweetalert2';
declare var bootstrap: any;
@Component({
  selector: 'app-workshop-details',
  templateUrl: './workshop-details.component.html',
  styleUrl: './workshop-details.component.scss'
})
export class WorkshopDetailsComponent implements OnInit {
  destroy$: Subject<boolean> = new Subject<boolean>();
  searchText: any = "";
  getListOfWorkshopDetails: WorkshopRegistrationDetails[] = [];
  getallWorkshopDetails: WorkshopRegistrationDetails[] = [];
  paymentDetailModal: boolean = false;
  regName: string = "";
  phoneNumber: number = 0;
  totalPaypalAmount: number = 0;
  bookedTicketsCount: number = 0;
  eventId: number = 0;
  participantBookingCount: number = 0;
  notCheckInCount: number = 0;
  checkedInCount: number = 0;
  eventDetails: EventBookingDetails[] = [];
  hostName: string = "";
  currentEventDetails: EventBookingDetails;
  whatsappMessage: string = "";

  constructor(
    private appService: AppService, private router: Router,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private aesService: AesEncryptionService,
    private httpClient: HttpClient
  ) {

  }
  ngOnInit(): void {
    this.eventDetailsGetAll();
    this.hostName = window.location.hostname;
  }

  eventDetailsGetAll() {
    this.spinner.show();
    this.appService.eventDetailsGetAll()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        const today = new Date().setHours(0, 0, 0, 0);
        const sorted = data
          .sort((a, b) => {
            const aIsFuture = a.startDate >= today;
            const bIsFuture = b.startDate >= today;
            if (aIsFuture && !bIsFuture) return -1;
            if (!aIsFuture && bIsFuture) return 1;
            return a.startDate - b.startDate;
          });
        this.eventDetails = sorted;
        this.spinner.hide();
      }, (error: any) => {
        this.spinner.hide()
        this.toastr.error(error?.error?.message || "Something Went Wrong, Please Try Again")
      });
  }

  showThankYouMail(event: EventBookingDetails): boolean {
    if (!event || !event.startDate || !event.startTime) return false;
    return this.isRegistrationClosed(event);
  }


  isRegistrationClosed(event: any): boolean {
    const now = Date.now();

    // Convert epoch startDate to real Date object
    const startDate = new Date(event.startDate);

    // Validate time string
    if (!event.startTime || !event.startTime.includes(' ')) return false;

    const [timePart, meridian] = event.startTime.trim().split(' ');
    let [hours, minutes] = timePart.split('.').map(Number);

    if (isNaN(hours)) return false;
    minutes = isNaN(minutes) ? 0 : minutes;

    // Convert to 24-hour format
    if (meridian.toUpperCase() === 'PM' && hours < 12) hours += 12;
    if (meridian.toUpperCase() === 'AM' && hours === 12) hours = 0;

    // Set hours/minutes on startDate
    startDate.setHours(hours, minutes, 0, 0);

    // Now compare
    return now > startDate.getTime();
  }

  formattedDate(epoch: number): string {
    const date = new Date(epoch);
    return date.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    });
  }


  getEventIdWorkshopDetails(eventId: number) {
    this.spinner.show();
    this.appService.getEventIdWorkshopDetails(eventId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        const sorted = data.sort((a, b) => b.workshopId - a.workshopId);
        this.getListOfWorkshopDetails = sorted;
        const totalAudience = this.getListOfWorkshopDetails
          .reduce((sum, item) => sum + (item.audienceDetails?.length || 0), 0)
        this.participantBookingCount = totalAudience;
        // Not Checked-in
        this.notCheckInCount = this.getListOfWorkshopDetails
          .reduce((sum, item) =>
            sum + (item.audienceDetails?.filter(a => a.attendanceStatus === 'Not Checkin').length || 0)
            , 0);

        // Checked-in
        this.checkedInCount = this.getListOfWorkshopDetails
          .reduce((sum, item) =>
            sum + (item.audienceDetails?.filter(a => a.attendanceStatus === 'Checked in').length || 0)
            , 0);
        this.participantBookingCount = totalAudience;
        this.spinner.hide();
      }, (error: any) => {
        this.spinner.hide();
        this.toastr.error(error.error.message || "Something Went Wrong,Please Try Again....")
      })
  }

  selectValue(event: any) {
    this.totalPaypalAmount = 0;
    this.bookedTicketsCount = 0;
    this.spinner.show();
    const eventId = +event.target.value;
    this.eventId = Number(eventId);
    this.currentEventDetails = this.eventDetails.find(item => item.eventId == eventId)
    this.getEventIdWorkshopDetails(this.eventId)
    this.spinner.hide();
  }

  getSubParticipantsNames(audience: any[]): string {
    if (!audience || audience.length <= 1) {
      return "-"; // No sub participants
    }

    // Skip the first participant and return others
    const subNames = audience.slice(1).map(a => a.participantName);

    return subNames.join(", "); // join with comma
  }

  getTicketUrl(ticketSeq: string) {
    const encrypted = this.aesService.encryptTicket(ticketSeq);
    const encoded = encodeURIComponent(encrypted);

    // Default URL (production)
    let baseUrl = 'https://ticket.velmaralsevatrust.org/index.html';

    // // For local & booking environments use cktechsoln ticket portal
    // if (this.hostName === 'localhost' || this.hostName === 'booking.cktechsoln.in') {
    //   baseUrl = 'https://ticket.cktechsoln.in/index.html';
    // }

    // // For ticket.cktechsoln.in host use velmaral domain
    // if (this.hostName === 'ticket.cktechsoln.in') {
    //   baseUrl = 'https://ticket.velmaralsevatrust.org/index.html';
    // }

    return `${baseUrl}?ticketNo=${encoded}`;
  }



  getPaymentStatus(transactions: any) {
    if (!transactions || !Array.isArray(transactions)) {
      return 'ON ERROR';
    }

    const hasCompleted = transactions.some(t => t.status === 'COMPLETED');
    return hasCompleted ? 'COMPLETED' : 'ON ERROR';
  }

  generateExcelSheet(): void {
    if (!this.getListOfWorkshopDetails?.length) {
      this.toastr.error("No data found to download!");
      return;
    }

    // 1. Prepare Data (No changes here)
    const excelData = this.getListOfWorkshopDetails.map((item, index) => {
      const participants = item.audienceDetails || [];
      const namesArr = participants.map(p =>
        p.participantName != null ? String(p.participantName) : '-'
      ).filter(Boolean);
      const phoneArr = participants
        .map(p => p.whatsappNumber ? String(p.whatsappNumber) : null)  // convert empty to null
        .filter(v => v !== null);
      const attendanceStatus = participants.map(p =>
        p.attendanceStatus != null ? String(p.attendanceStatus) : '-'
      ).filter(Boolean);
      return {
        'S.No': index + 1,
        'Ticket No': item?.audienceDetails[0]?.ticketSeq,
        'Participant Names': namesArr.join('\n'),
        'Phone Number': phoneArr.length ? phoneArr.join('\n') : '-',  // <--- FIXED
        'Email': item?.emailId || '-',
        'Address': item?.address || '-',
        'Registered Date': item.createdAt ? new Date(item.createdAt).toLocaleDateString() : '-',
        'Participant Count': item.audienceDetails.length ?? 0,
        "Checking Status": attendanceStatus.join('\n')
      };
    });

    // 2. Create Worksheet
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);

    // 3. Define Styles
    const headerStyle = {
      font: { bold: true },
      fill: { patternType: 'solid', fgColor: { rgb: 'FFFF00' } }, // Yellow
      alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
    };

    const defaultCenterStyle = {
      alignment: {
        wrapText: true,
        vertical: 'center',
        horizontal: 'center',
      },
    };

    // * UPDATED *: Style for the 'Total Amount' column, now right-aligned
    const amountRightStyle = {
      alignment: {
        wrapText: true,
        vertical: 'center',
        horizontal: 'right', // Aligned to the right
      },
    };

    // 4. Set Column Widths and Row Heights
    ws['!cols'] = [
      { wch: 6 }, { wch: 20 }, { wch: 30 }, { wch: 10 }, { wch: 15 },
      { wch: 35 }, { wch: 35 }, { wch: 25 }, { wch: 25 }, { wch: 15 },
      { wch: 16 }, { wch: 15 }, { wch: 15 },
    ];

    // * UPDATED *: Increased row heights for better visibility
    const rowHeights = excelData.map(row => {
      const lines = (String(row['Participant Names']).match(/\n/g) || []).length + 1;
      return { hpx: Math.max(20, lines * 25) }; // Increased multiplier to 25
    });
    ws['!rows'] = [{ hpx: 30 }, ...rowHeights]; // Increased header height to 30

    // 5. Apply Styles to Cells
    const range = XLSX.utils.decode_range(ws['!ref']!);
    for (let c = range.s.c; c <= range.e.c; ++c) {
      const headerAddress = XLSX.utils.encode_cell({ r: 0, c });
      if (ws[headerAddress]) ws[headerAddress].s = headerStyle;

      for (let r = range.s.r + 1; r <= range.e.r; ++r) {
        const cellAddress = XLSX.utils.encode_cell({ r, c });
        const cell = ws[cellAddress];
        if (!cell) continue;

        const headerName = ws[XLSX.utils.encode_cell({ r: 0, c })]?.v;

        if (headerName === 'Total Amount') {
          cell.s = amountRightStyle; // Use right-align style
        } else {
          cell.s = defaultCenterStyle; // Use center-align for all others
        }
      }
    }

    // 6. Generate and Save File
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Registrations');
    const wbout: ArrayBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'RegistrationData.xlsx');
  }

  sendReminderEmails(workshopId: number) {
    console.log(workshopId)
    this.spinner.show();
    this.appService.sendReminderEmails(workshopId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.toastr.success("Email Send Successfully....")
        this.spinner.hide();
      }, (error: any) => {
        this.spinner.hide();
        this.toastr.error(error?.error?.message || "Something Went Worng,Please Try Aagin...")
      })
  }

  sendReminderWhatsapp(workshopId : number){
    console.log(workshopId)
    this.spinner.show();
    this.appService.sendReminderWhatsapp(workshopId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.toastr.success("WhatsApp Send Successfully....")
       this.spinner.hide();
      },(error : any) =>{
        this.spinner.hide();
        this.toastr.error(error?.error?.message || "Something Went Worng,Please Try Aagin...")
      })
  }


  SendReminderBulkWhatsapp() {

  const workshopIds = this.getListOfWorkshopDetails
    .map(item => item.workshopId)
    .filter(id => id !== null && id !== undefined);

  if (!workshopIds.length) {
    Swal.fire({
      icon: 'warning',
      title: 'No Data',
      text: 'No Participants found to send reminder.'
    });
    return;
  }

  Swal.fire({
    title: 'Are you sure?',
    text: 'Do you want to send WhatsApp reminder to selected participants?',
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'Yes, Send',
    cancelButtonText: 'Cancel',
    confirmButtonColor: '#28a745'
  }).then((result) => {

    if (result.isConfirmed) {

      const payload = {
        workshopIds: workshopIds
      };
      this.spinner.show();
      this.appService.sendReminderBulkWhatsapp(payload)
        .subscribe({
          next: () => {
            this.spinner.hide();
            Swal.fire({
              icon: 'success',
              title: 'Sent!',
              text: 'Bulk WhatsApp reminders sent successfully.'
            });
          },
          error: () => {
            this.spinner.hide();
            Swal.fire({
              icon: 'error',
              title: 'Failed',
              text: 'Failed to send WhatsApp reminders. Try again.'
            });
          }
        });

    }
  });
}


  formatTime(time: string): string {
    if (!time) return "";

    // Example: "2:00 AM"
    const [t, meridiem] = time.split(" ");  // t = "2:00", meridiem = "AM"
    let [hour, minute] = t.split(":");      // hour = "2"

    // pad hour to 2 digits
    hour = hour.padStart(2, "0");

    // return without space before AM/PM
    return `${hour}:${minute}${meridiem}`;
  }


  // 1. When clicking the WhatsApp icon
  openWhatsappModal(work: any) {
    this.phoneNumber = work?.phoneNumber
    const names = work?.name;
    const count = work?.audienceDetails.length;
    const ticketSeq = this.getTicketUrl(work.audienceDetails[0]?.ticketSeq);
    const googleMapLink = this.currentEventDetails?.mapEmbeddedLink;
    const groupLink = this.currentEventDetails?.whatsappGroupLink;
    const channelLink = "https://whatsapp.com/channel/0029VamF31TGZNChhDu7Nl0R";
    const city = this.currentEventDetails?.city;
    const { date } = this.formatEpochDateTime(this.currentEventDetails?.eventDate);
    const time = this.currentEventDetails?.startTime;
    this.whatsappMessage = `
முருகா சரணம்
வாழ்வை மாற்றும் வேல்மாறல் வழிபாடு – ${city} பதிவு உறுதிப்படுத்தப்பட்டது

அன்புள்ள பக்தரே,
உங்கள் பதிவு வெற்றிகரமாக நிறைவு பெற்றது.
இந்த புனித வேல்மாறல் வழிபாட்டில் கலந்து கொள்ளும் உங்களுக்கு முருகப்பெருமான் அருளாசி கிடைக்கப் பெற வாழ்த்துகிறோம்.

நாள்: ${date}
நேரம்: ${time}

உங்கள் பதிவு விவரங்கள்
------------------------------
பங்கேற்பாளர் பெயர்கள் : ${names}
பங்கேற்பாளர் எண்ணிக்கை : ${count}

இடம்: ${city}
Google Map Link: ${googleMapLink}

உங்கள் பதிவு மற்றும் QR கோடு லிங்க்:
${this.getTicketUrl(ticketSeq)}

Join our ${city} WhatsApp group: ${groupLink}

வேலின் அருள் வாழ்க்கையை ஒளிரச் செய்யட்டும். 
முருகனின் திருவருள் எப்போதும் உங்களோடு இருக்கட்டும்.

Follow the Channel:
${channelLink}

உதவி மற்றும் தொடர்புக்கு: 91 7339663756

இப்படிக்கு,
வேல் மாறல் சேவா அறக்கட்டளை
`;

    const modal = new bootstrap.Modal(document.getElementById('whatsappModal'));
    modal.show();
  }

  // 2. Copy message with full formatting
  copyMessage() {
    if (!this.whatsappMessage) {
      this.toastr.error("No message found to copy!");
      return;
    }

    // Copy the message
    if (navigator.clipboard) {
      navigator.clipboard.writeText(this.whatsappMessage)
        .then(() => {
          this.toastr.success("Message Copied");

          // Close modal after copy
          this.closeWhatsappModal();
        })
        .catch(() => {
          this.copyFallback();
        });
    } else {
      this.copyFallback();
    }
  }


  copyFallback() {
    // Fallback for browsers without navigator.clipboard (iOS Safari etc.)
    const textarea = document.createElement('textarea');
    textarea.value = this.whatsappMessage;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';

    document.body.appendChild(textarea);
    textarea.select();

    try {
      document.execCommand('copy');
      this.toastr.success("Message Copied");
    } catch (err) {
      this.toastr.error("Failed to copy message");
    }

    document.body.removeChild(textarea);
  }

  closeWhatsappModal() {
    const modalEl = document.getElementById('whatsappModal');
    const modal = bootstrap.Modal.getInstance(modalEl);  // get modal instance

    if (modal) {
      modal.hide();
    }
  }



  // 3. Send message to WhatsApp
  sendWhatsapp() {
    if (!this.phoneNumber) {
      this.toastr.error("Phone number missing!");
      return;
    }

    const encoded = encodeURIComponent(this.whatsappMessage);

    window.open(
      `https://api.whatsapp.com/send?phone=91${this.phoneNumber}&text=${encoded}`,
      "_blank"
    );
  }


  formatEpochDateTime(epoch: number) {
    if (!epoch) return { date: '', time: '' };

    const d = new Date(epoch);

    // Date Format: DD-MM-YYYY
    const date = d.toLocaleDateString('ta-IN', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });

    // Time Format: 12-hour with AM/PM
    const time = d.toLocaleTimeString('ta-IN', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });

    return { date, time };
  }


}
